import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { toast } from 'sonner';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Recital, RecitalSettings } from '../model/recital';

export interface CreateRecitalParams {
  name: string;
  year: number;
  startDate: string;
  endDate: string;
  description?: string;
  settings?: Partial<RecitalSettings>;
}

export const createRecitalAPI = async (params: CreateRecitalParams) => {
  const response = await baseAPI.post<Recital>('/recitals', params);
  return response.data;
};

export const useCreateRecitalMutation = () => {
  return useMutation({
    mutationFn: async (params: CreateRecitalParams) => {
      return await createRecitalAPI(params);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.RECITALS],
      });
    },
    onError: (error: AxiosError<{ message: string }>) => {
      const errorMessage =
        error.response?.data.message ?? 'Failed to create recital';
      toast.error(errorMessage);
    },
  });
};
